<div class="address-card">
  <span class="icon-map"></span>
  <div>
    <!-- <div class="address-card__name">{{ 'pages.common.fields.mainAddress' | translate }}</div> -->
    <div class="address-card__address" *ngIf="formattedAddress">{{ formattedAddress }}</div>
    <button *ngIf="!formattedAddress" class="bciti-inline-button" (click)="editAddress()">{{ 'common.geoid.searchAddressHeading' | translate }}</button>
  </div>
  <button class="icon-edit" (click)="editAddress()"></button>
</div>
<div *ngIf="!disableMessages" class="messages">
  <ng-content selector="app-form-error"></ng-content>
  <ng-content selector="app-form-success"></ng-content>
</div>
